/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Patient Indicator Custom hook.
 */

// Dependencies
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const usePatientIndicators = (indicatorId) => {
  const patientIndicators = useSelector((state) =>
    state.getIn(['AppState', 'patientIndicators'])
  );

  const [filteredIndicators, setfilteredIndicators] = useState([]);

  useEffect(() => {
    const indicators = patientIndicators.filter(
      (patientIndicator) => patientIndicator.indicador_id === indicatorId
    );
    setfilteredIndicators(indicators);
  }, [patientIndicators]);

  return filteredIndicators;
};

export default usePatientIndicators;
